export default function StaffApi({ makeRequest, buildRequest }) {

    function getStaffByParent(parentId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Staff/ByParent/${parentId}`));
        });
    }

    function getStaffById(staffId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Staff/${staffId}`));
        });
    }

    function createStaff(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Staff/Create', payload));
        });
    }

    function getOtherAssignments(parentId, roleId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Staff/OtherAssignments/${parentId}/${roleId}`));
        });
    }

    function upsertStaff(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Staff/Upsert', payload));
        });
    }

    function deleteStaff(staffId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Staff/${staffId}`));
        });
    }

    function searchEntraStaff(searchString, signal) {
        return buildRequest().then(function (req) {
            return makeRequest(
                req.get('/api/Staff/entra', {
                    params: { searchString },
                    signal,
                    suppressErrorToast: true,
                })
            );
        });
    }

    function getEntraStaffPhoto(id, signal) {
        return buildRequest().then(function (req) {
            return makeRequest(
                req.get(`/api/Staff/entra/${id}/photo`, {
                    responseType: 'blob',
                    signal,
                    suppressErrorToast: true,
                })
            );
        });
    }

    function getStaffRoleList(staffId, signal) {
        return buildRequest().then(function (req) {
            return makeRequest(
                req.get(`/api/Staff/RoleList/${staffId}`, {
                    signal,
                    suppressErrorToast: true,
                })
            );
        });
    }

    // Staff Tags
    function getStaffTags(staffId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Staff/Tags/${staffId}`));
        });
    }

    function upsertStaffTag(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Staff/Tags/Upsert', payload));
        });
    }

    function deleteStaffTag(centreStaffTagId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Staff/Tags/${centreStaffTagId}`));
        });
    }

    return {
        getStaffByParent,
        getStaffById,
        createStaff,
        getOtherAssignments,
        upsertStaff,
        deleteStaff,
        searchEntraStaff,
        getEntraStaffPhoto,
        getStaffRoleList,
        getStaffTags,
        upsertStaffTag,
        deleteStaffTag,
    };
}
